// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"VJ-z","carouselContainer":"WJ-z"};